export var Cfg = {
      BackendUrl:    'https://finsumma.com/bkd',
      BackendUrladj: 'https://finsumma.com',

    // BackendUrl: 'http://194.195.216.61/bkd',
    // BackendUrladj: 'http://194.195.216.61',
        
    
    //  BackendUrl: 'http://localhost:3000/bkd',    
    //  BackendUrladj: 'http://localhost:3000',

    formatoFecha: 'dd/MM/yyyy',
    devempresa:'MKSoftware',
    navnombre:'SUMMA',    
    listaUsuarios : [ 
        {Usuario:'CVARGAS'},
        {Usuario:'DCARRETO'},
        {Usuario:'EARENAS'},
        {Usuario:'EDEPAZ'},
        {Usuario:'ERODAS'},
        {Usuario:'GZELADA'},
        {Usuario:'HIXPATA'},
        {Usuario:'IRIZZO'},
        {Usuario:'JGUTIERREZ'},
        {Usuario:'JMONTERROS'},
        {Usuario:'JSEGURA'},
        {Usuario:'LPOP'},
        {Usuario:'LVALLE'},
        {Usuario:'MESTEBAN'},
        {Usuario:'MGARCIA'},
        {Usuario:'MGONZALEZ'},
        {Usuario:'MVIELMAN'},
        {Usuario:'NBERCIAN'},
        {Usuario:'RHERNANDEZ'},
        {Usuario:'SYAGUAS'},
        {Usuario:'VRAYMUNDO'},
        {Usuario:'WDUARTE'},
        {Usuario:'WGUACHIN'},
        {Usuario:'YCARRERA'}        
    ],
    

listaEstatus : [
    {Estatus:'ARCHIVADO'},
    {Estatus:'BORRADOR'},
    {Estatus:'EN PROCESO'},
    {Estatus:'FINALIZADO'},
    {Estatus:'VALIDADO'}
],
listaEmpresas : [
    {Empresa:'FINANCIERA SUMMA, S.A.'},
    {Empresa:'ATF'},
    {Empresa:'VALORES SUMMA, SOCIEDAD ANONIMA'}
],
listaEmpresasMulti : [
    {value:'FINANCIERA SUMMA, S.A.',label:'FINANCIERA SUMMA, S.A.'},
    {value:'ATF',label:'ATF'},
    {value:'VALORES SUMMA, SOCIEDAD ANONIMA',label:'VALORES SUMMA, SOCIEDAD ANONIMA'}],
    listaEmpresasGrupoAdmin : [
        {value:'ADMIN',label:'ADMIN'},
        {value:'BASICO',label:'BASICO'},
        {value:'NEGOCIOS',label:'NEGOCIOS'},
        {value:'FIBBO',label:'FIBBO'},
        {value:'FIDEICOMISOS',label:'FIDEICOMISOS'}
    ],


}


	